import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import { rootReducer } from "./store/reducer";
import Login from "./pages/Login";
// import Home from "./pages/Home";
import Layout from "./component/template/layout";
import UserManagememt from "./pages/UserManagement";
import ChhartMonitor from "./component/template/ChartMonitor";
import Welcome from "./pages/Welcome";
import SensorMonitor from "./pages/SensorMonitor";
import StructureMonitor from "./pages/StructureMonitor";
import LupaPassword from "./pages/LupaPassword";
import Daftar from "./pages/Daftar";
import SetPassword from "./pages/SetPassword";
import SystemAudit from "./pages/SystemAudit";
import HistoryTreshold from "./pages/HistoryTreshold";
import PrivateRoute from "./helper/PrivatRoute";
import PublicRoute from "./helper/PublicRoute";
// import { fetchApi } from "./helper/api";
import UserManagememtRole from "./pages/UserManagementRole";
import Tunggu from "./pages/WaitingConfirmation";
import WaitingConfirmationForgotPassword from "./pages/WaitingConfirmationForgotPassword";
import FieldReport from "./pages/FieldReport";
import ChartMonitorMobile from "./component/template/ChartMonitorMobile";
import FftGraphMobile from "./component/template/FftGraphMobile";
import Maps from "./pages/Maps";
import ListIPC from "./pages/ListIPC";
import CameraStreaming from "./component/organisms/CameraStreaming";
// import HistoryTresholdBridge from "./pages/HistoryTresholdBridge";
import DownloadReport from "./component/organisms/DownloadReport";
import HomeEdit from "./pages/HomeEdit";
import { PlaybackData } from "./component/template/PlaybackData";
import "reactflow/dist/style.css";

const store = createStore(rootReducer);

export default function App() {
  const registerServiceWorker = async () => {
    if ("serviceWorker" in navigator) {
      try {
        const registration = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
        });
        if (registration.installing) {
          console.log("Service worker installing");
        } else if (registration.waiting) {
          console.log("Service worker installed");
        } else if (registration.active) {
          console.log("Service worker active");
        }
      } catch (error) {
        console.error(`Registration failed with ${error}`);
      }
    }
  };
  // let location = useLocation();
  // let navigate = useNavigate();
  // let params = useParams();

  return (
    <div className="App">
      <Provider store={store}>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route path="/dashboard" element={<HomeEdit />} />
            <Route path="/user-management/user" element={<UserManagememt />} />
            <Route
              path="/user-management/role"
              element={<UserManagememtRole />}
            />
            <Route
              path="/structure-monitor"
              element={<Maps tipe="structure" />}
            />
            <Route
              path="/structure-monitor/:id"
              element={<StructureMonitor />}
            />
            <Route path="/sensor-monitor" element={<Maps tipe="sensor" />} />
            <Route path="/sensor-monitor/:id" element={<SensorMonitor />} />
            <Route
              path="/sensor-monitor/chart/:ipc/:id"
              element={<ChhartMonitor />}
            />
            <Route path="/playback-data" element={<PlaybackData />} />
            <Route
              path="/sensor-monitor/history/:id"
              element={<HistoryTreshold type="sensor" />}
            />
            <Route
              path="/sensor-monitor/history-bridge/:id"
              element={<HistoryTreshold type="bridge" />}
            />
            <Route path="/download/:id" element={<DownloadReport />} />
            <Route path="/list-ipc/:id" element={<ListIPC />} />
            <Route path="/sistem-audit" element={<SystemAudit />} />
            <Route path="/field-report" element={<FieldReport />} />
            <Route path="/camera-streaming" element={<CameraStreaming />} />
          </Route>
          <Route
            path="login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path="lupa-password" element={<LupaPassword />} />
          <Route
            path="daftar"
            element={
              <PublicRoute>
                <Daftar />
              </PublicRoute>
            }
          />
          <Route path="set-password" element={<SetPassword />} />
          <Route
            path="waiting-confirmation"
            element={
              <PublicRoute>
                <Tunggu />
              </PublicRoute>
            }
          />
          <Route
            path="mobile/sensor-monitor/:id"
            element={<ChartMonitorMobile />}
          />
          <Route path="mobile/sensor-fft/:id" element={<FftGraphMobile />} />
          <Route
            path="waiting-confirmation-forgot-password"
            element={<WaitingConfirmationForgotPassword />}
          />
        </Routes>
      </Provider>
    </div>
  );
}
